import { render, staticRenderFns } from "./CaseTimeline.vue?vue&type=template&id=641f308d&scoped=true&"
import script from "./CaseTimeline.vue?vue&type=script&lang=ts&"
export * from "./CaseTimeline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f308d",
  null
  
)

export default component.exports